import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

const ProductVariantsModal = ({ show, product, onClose }) => {
    const [selectedVariantId, setSelectedVariantId] = useState(null);

    const handleSelect = (id) => setSelectedVariantId(id);

    return (
        <Modal show={!!show} onHide={onClose} centered backdrop="static">
            <Modal.Header closeButton className="py-2">
                <Modal.Title className="h5">{product?.name || "Select Variant"}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex flex-column gap-3">
                    {(product?.variants || []).map((variant, idx) => (
                        <div
                            key={variant.id}
                            className={`variant-card rounded border ${selectedVariantId === variant.id ? 'selected' : ''}`}
                            onClick={() => handleSelect(variant.id)}
                        >
                            <div className="d-flex align-items-start">
                                <div className="custom-checkbox form-check p-0" style={{ top: '-5px' }}>
                                    <input
                                        id={`pv-variant-${idx}`}
                                        type="radio"
                                        name="pv-variant"
                                        value={variant.id}
                                        checked={selectedVariantId === variant.id}
                                        onChange={() => handleSelect(variant.id)}
                                    />
                                    <label className="custom-label" htmlFor={`pv-variant-${idx}`}></label>
                                </div>
                                <div className="flex-grow-1 ms-1">
                                    <h6 className="mb-1 fw-semibold">{variant.name}</h6>
                                    <p className="text-muted fs-15px">{variant.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Link
                    onClick={onClose}
                    className={`btn btn-primary ms-2 ${!selectedVariantId ? 'disabled' : ''}`}
                >
                    Save
                </Link>
            </Modal.Footer>
        </Modal>
    );
};

export default ProductVariantsModal;
